module.exports = __webpack_public_path__ + "img/Curdr-login-05.d64823c5.png";